
import apiClient from './axios';

const exhibitionApi = {
  getAll: async (page = 1, pageSize = 10, search = '') => {
    const response = await apiClient.get('/exhibition/', {
      params: { page, page_size: pageSize, search },
    });
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/exhibition/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.patch(`/exhibition/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/exhibition/${id}/`);
    return id;
  },

  exportCsv: async () => {
    const response = await apiClient.get('/exhibition/export/', {
      responseType: 'blob',
    });
    return response.data;
  },

  importPreview: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/exhibition/import-preview/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  importConfirm: async (preview) => {
    const response = await apiClient.post('/exhibition/import-confirm/', { preview });
    return response.data;
  },

  bulkCreateMembers: async (data) => {
    // data is array: [{ exhibition: "...", employee: "..." }, ...]
    const response = await apiClient.post('/exhibition-members/bulk_create/', data);
    return response.data;
  },

  
  bulkCreateAssignments: async (data) => {
    // data is array: [{ exhibition_member, sub_category, assign_quantity }, ...]
    const response = await apiClient.post('/exhibition-member-assignments/bulk_create/', data);
    return response.data;
  },
  
  // Members
  getMembers: async (page = 1, pageSize = 10, search = '', exhibition='') => {
    const response = await apiClient.get('/exhibition-members/', {
      params: { page, page_size: pageSize, search, exhibition },
    });
    return response.data;
  },

  createMember: async (data) => {
    const response = await apiClient.post('/exhibition-members/', data);
    return response.data;
  },

  updateMember: async (id, data) => {
    const response = await apiClient.patch(`/exhibition-members/${id}/`, data);
    return response.data;
  },

  deleteMember: async (id) => {
    await apiClient.delete(`/exhibition-members/${id}/`);
    return id;
  },

  exportMembers: async () => {
    const response = await apiClient.get('/exhibition-members/export/', {
      responseType: 'blob',
    });
    return response.data;
  },

  importMemberPreview: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/exhibition-members/import-preview/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  importMemberConfirm: async (preview) => {
    const response = await apiClient.post('/exhibition-members/import-confirm/', { preview });
    return response.data;
  },

  // Assignments
  getAssignments: async (page = 1, pageSize = 10, search = '', exhibition_member__exhibition='') => {
    const response = await apiClient.get('/exhibition-member-assignments/', {
      params: { page, page_size: pageSize, search, exhibition_member__exhibition },
    });
    return response.data;
  },

  createAssignment: async (data) => {
    const response = await apiClient.post('/exhibition-member-assignments/', data);
    return response.data;
  },

  updateAssignment: async (id, data) => {
    const response = await apiClient.patch(`/exhibition-member-assignments/${id}/`, data);
    return response.data;
  },

  deleteAssignment: async (id) => {
    await apiClient.delete(`/exhibition-member-assignments/${id}/`);
    return id;
  },

  exportAssignments: async () => {
    const response = await apiClient.get('/exhibition-member-assignments/export/', {
      responseType: 'blob',
    });
    return response.data;
  },

  importAssignmentPreview: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/exhibition-member-assignments/import-preview/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  importAssignmentConfirm: async (preview) => {
    const response = await apiClient.post('/exhibition-member-assignments/import-confirm/', { preview });
    return response.data;
  },

  // ────────────────────────────────────────────────
  // Assignment Actions
  // ────────────────────────────────────────────────
  acknowledge: async (id, is_accepted) => {
    const response = await apiClient.post(`/exhibition-member-assignments/${id}/acknowledge/`, { is_accepted });
    return response.data;
  },

  requestReturn: async (id, return_quantity) => {
    const response = await apiClient.post(`/exhibition-member-assignments/${id}/request-return/`, { return_quantity });
    return response.data;
  },

  confirmReturn: async (id, is_accepted) => {
    const response = await apiClient.post(`/exhibition-member-assignments/${id}/confirm-return/`, { is_accepted });
    return response.data;
  },

  // Visitors
  getVisitors: async (page = 1, pageSize = 10, search = '', exhibition='') => {
    const response = await apiClient.get('/visitor-details/', {
      params: { page, page_size: pageSize, search, exhibition },
    });
    return response.data;
  },

  createVisitor: async (formData) => {
    const response = await apiClient.post('/visitor-details/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  updateVisitor: async (id, formData) => {
    const response = await apiClient.patch(`/visitor-details/${id}/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  deleteVisitor: async (id) => {
    await apiClient.delete(`/visitor-details/${id}/`);
    return id;
  },

  exportVisitors: async () => {
    const response = await apiClient.get('/visitor-details/export/', {
      responseType: 'blob',
    });
    return response.data;
  },

  importVisitorPreview: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/visitor-details/import-preview/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  importVisitorConfirm: async (preview) => {
    const response = await apiClient.post('/visitor-details/import-confirm/', { preview });
    return response.data;
  },
};

export default exhibitionApi;